import {ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {CouponStatus} from '@app/models/v3/coupon';
import {couponStatusColor} from '@app/models/v3/coupon-fn';

@Component({
    selector: 'app-coupon-status',
    template: `
        <p-tag [styleClass]="styleClass">{{ status }}</p-tag>
    `,
    styles: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CouponStatusComponent implements OnChanges {
    @Input() status: CouponStatus;

    styleClass: string;

    constructor() {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.status) {
            this.styleClass = couponStatusColor(this.status);
        }
    }
}
